//TODO: Improve readability
import * as yup from 'yup';

import {
  LC_PAGE_COMPETENCY_CHAR_LIMIT,
  LC_PAGE_SUBJECT_CHAR_LIMIT,
  LP_PAGE_OBJECTIVE_CHAR_LIMIT,
} from '@lessonPlanner/constants';

const charLimitTest = (limit: number) => (val: string) =>
  !val || val.length <= limit;

export const gradeLevel = yup.string().required('Please select a grade level');

export const subject = yup
  .string()
  .required('Please enter a subject')
  .test(
    'len',
    'You have reached the character limit',
    charLimitTest(LC_PAGE_SUBJECT_CHAR_LIMIT),
  );

export const language = yup.string().required('Please select a translation');

export const topic = yup
  .string()
  .required('Please enter topic')
  .test(
    'len',
    'You have reached the character limit',
    charLimitTest(LC_PAGE_COMPETENCY_CHAR_LIMIT),
  );

export const assessmentType = yup
  .string()
  .required('Please select an Assessment Type');

export const additionalInformation = yup.string();

export const time = yup.string().required('Please select a duration');

export const number = yup
  .string()
  .required('Please select number of questions');

export const difficulty = yup
  .string()
  .required('Please select difficulty level');

export const curriculumFramework = yup
  .string()
  .required('Please enter the Curriculum Framework');

export const specificStandards = yup
  .string()
  .required('Please enter the Standard to be followed')
  .test(
    'len',
    'You have reached the character limit',
    charLimitTest(LC_PAGE_SUBJECT_CHAR_LIMIT),
  );

export const textArea = yup
  .string()
  .required('Please enter objective')
  .test(
    'len',
    'You have reached the character limit',
    charLimitTest(LP_PAGE_OBJECTIVE_CHAR_LIMIT),
  );

export const optionalTextArea = yup
  .string()
  .test(
    'len',
    'You have reached the character limit',
    charLimitTest(LP_PAGE_OBJECTIVE_CHAR_LIMIT),
  );

export const strategies = yup
  .string()
  .optional()
  .test(
    'len',
    'You have reached the character limit',
    charLimitTest(LC_PAGE_SUBJECT_CHAR_LIMIT),
  );
